import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultReportLinkModel = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as ReportLinkEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<ReportLinkEditCriteria>,
}

export interface ReportLinkEditCriteria {
  reportLink_Id: number;
  reportName: string;
  reportUrl: string;
  description: string;
  country: string;
}
